export default "__VITE_ASSET__D_QrtbPE__"